
import '../ModalStyle.scss'
import { Form } from 'react-bootstrap'
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage } from '../../../../utils/commonFunctions'
import CustomSelect from '../../../CommonComponents/CustomSelect'
import { FC, useMemo } from "react"
import { SelectedSatelliteType, PayloadType, SelectedPayloadType } from "./QuickDeployModal"
import { showToastMessage } from '../../../../utils/commonFunctions'


interface DetailsForm {
    scenarioTitle: string,
    scenarioDescription: string,
    selectedGroup: SelectedSatelliteType | null,
    all_satellites: SelectedSatelliteType[] | [],
    setScenarioTitle: (value: string) => void
    setSelectedGroup: (value: SelectedSatelliteType) => void,
    all_payloads: PayloadType[];
    selectedPayload: SelectedPayloadType | null;
    setSelectedPayload: (payload: SelectedPayloadType | null) => void;
    setScenarioDescription: (value: string) => void;

}

const DetailsForm: FC<DetailsForm> = ({ scenarioTitle, selectedGroup, all_satellites, setScenarioTitle, setSelectedGroup, all_payloads, selectedPayload, setSelectedPayload, scenarioDescription, setScenarioDescription }) => {
    const singleSatGroupArray = useMemo(() => all_satellites.filter(item => item.value['satCount'] === 1 && item.value['draftMode'] === false), [all_satellites])

    return (
        <Form className='w-100 d-flex flex-column gap-3'>
            <div className='w-100 d-flex flex-column gap-1'>
                <span className='opacity-75 fs-14'>Title *</span>
                <Form.Control
                    value={scenarioTitle}
                    onChange={(e) => {
                        if (containsSpecialChars(e.target.value)) {
                            showToastMessage('error', getSpecialCharacterMessage())
                        } else if (e.target.value?.length <= 26) {
                            setScenarioTitle(e.target.value.trimStart())
                        } else {
                            showToastMessage('error', getCharacterLimitMessage(26))
                        }
                    }}
                    className="custom__text__input"
                    type="text"
                    placeholder="Title"
                    required
                />
            </div>
            <div className="w-100 mw-100">
                <span className='opacity-75 fs-14'>Description</span>
                <div className="d-flex">
                    <Form.Control
                        className='custom__text__input'
                        as="textarea"
                        placeholder={"Description"}
                        value={scenarioDescription}
                        onChange={(e) => {
                            if (containsSpecialChars(e.target.value)) {
                                showToastMessage('error', getSpecialCharacterMessage())
                            } else if (e.target.value?.length <= 200) {
                                setScenarioDescription(e.target.value.trimStart())
                            } else {
                                showToastMessage('error', getCharacterLimitMessage(200))
                            }
                        }}
                        style={{ resize: 'none', height: '75px', color: "#8E8E8E" }}
                    />
                </div>
            </div>
            <div className='info-msg-div'>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_10627_24821)">
                        <path d="M7.99992 14.6654C11.6818 14.6654 14.6666 11.6806 14.6666 7.9987C14.6666 4.3168 11.6818 1.33203 7.99992 1.33203C4.31802 1.33203 1.33325 4.3168 1.33325 7.9987C1.33325 11.6806 4.31802 14.6654 7.99992 14.6654Z" stroke="#F0F0F0" stroke-opacity="0.8" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8 10.9999L8 7" stroke="#F0F0F0" stroke-opacity="0.8" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8 5H8.00667" stroke="#F0F0F0" stroke-opacity="0.8" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_10627_24821">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <span className='info-msg-text'>
                    Quick Deploy can be performed only for single satellite groups.
                </span>
            </div>
            <div className='w-100 d-flex align-items-center justify-content-between gap-2 flex-row'>
                <div className='w-100 d-flex flex-column gap-1 flex-1'>
                    <span className="opacity-50 fs-14">Group</span>
                    <CustomSelect
                        options={singleSatGroupArray}
                        placeholder='Select Satellite'
                        value={selectedGroup}
                        onChange={(e: { label: string, value: any }) => {
                            setSelectedGroup(e)
                            setSelectedPayload(null)
                        }}
                    />
                </div>
                <div className='w-100 d-flex flex-column gap-1 flex-1'>
                    <span className="opacity-50 fs-14">Component</span>
                    <CustomSelect
                        options={selectedGroup && selectedGroup ? all_payloads : []}
                        placeholder='Select Payload'
                        value={selectedPayload ? { label: selectedPayload.name, value: selectedPayload } : null}
                        onChange={(e: PayloadType) => {
                            setSelectedPayload(e.value)
                        }}
                    />
                </div>
            </div>
        </Form>
    )
}

export default DetailsForm